import { render, staticRenderFns } from "./RolesEditor.vue?vue&type=template&id=508a0642"
import script from "./RolesEditor.vue?vue&type=script&lang=js"
export * from "./RolesEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports